import React, { useState } from 'react';

import AdminLayout from '../Layouts/AdminLayout';

import OrderList from '../Components/OrderList';

function App() {
    const [loading, setLoading] = useState(false);
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const formatDateBR = (dateStr) => {
        const [day, month, year] = dateStr.split('/');
        if (!day || !month || !year) return '';
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    const handleExport = async () => {
        setLoading(true);

        try {
            const params = new URLSearchParams(window.location.search);

            const statusMap = {
                'Importado da Bling': 'waiting',
                'Aguardando fornecedor': 'sent',
                'Aceito pelo fornecedor': 'accepted',
                'Rejeitado pelo fornecedor': 'rejected',
                'Faturamento autorizado': 'invoice_authorized',
                'Faturamento rejeitado': 'invoice_unauthorized',
                'NF Enviada': 'invoiced',
                'Faturado fornecedor': 'invoiced_supplier',
                'Arquivos enviados': 'shipped',
            };

            const mappedParams = new URLSearchParams({
                ...(params.get('orderNumber') && { customer: params.get('OrderNumber') }),
                ...(params.get('status') && {
                    status: statusMap[params.get('status')] || '',
                }),
                ...(params.get('dateFrom') && { start: formatDateBR(params.get('dateFrom'))}),
                ...(params.get('dateTo') && { end: formatDateBR(params.get('dateTo'))}),
                ...(params.get('origin') && { origin: params.get('origin') }),
                ...(params.get('customerName') && { customer: params.get('customerName') }),
                ...(params.get('uf') && { uf: params.get('uf') }),
            });

            const response = await fetch(`${baseUrl}/orders/export?${mappedParams.toString()}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) throw new Error('Erro ao exportar planilha');

            const disposition = response.headers.get('Content-Disposition');
            let filename = '';

            if (disposition && disposition.includes('filename=')) {
                const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    filename = match[1].replace(/['"]/g, '');
                }
            }

            if (!filename) {
                const now = new Date();
                const pad = (n) => String(n).padStart(2, '0');
                const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}`;
                filename = `Pedidos-${timestamp}.xlsx`;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Erro no download:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AdminLayout>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                <div className="mt-4 grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                    <div className="col-span-12">
                        <div className="rounded-sm border border-stroke bg-white px-5 pb-2.5 pt-6 shadow sm:px-7.5 xl:pb-1">
                            <div className="flex items-center justify-between">
                                <h4 className="mb-6 text-xl font-bold text-black">
                                    Pedidos
                                </h4>

                                <button onClick={handleExport} className="relative bg-primary py-2 px-4 text-white font-bold rounded transition-all hover:bg-tertiary">
                                    <span className={loading && 'opacity-0'}>Exportar Planilha</span>
                                    {loading && (
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <div className="h-5 w-5 animate-spin rounded-full border-2 border-solid border-white border-t-transparent" />
                                        </div>
                                    )}
                                </button>
                            </div>

                            <div className="flex flex-col">
                                <OrderList />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
}

export default App;